/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import Search from 'flarum/forum/components/Search';
import ArticleSearchSource from './components/ArticleSearchSource';

export default function addArticleSearchSource(): void {
	extend(Search.prototype, 'sourceItems', function (items) {
		items.add('articles', new ArticleSearchSource());
	});
}
